// extracted by mini-css-extract-plugin
export default {"wrapper":"Auth_wrapper__FGZH1","container":"Auth_container__4ehgw","form":"Auth_form__EYB9W","label":"Auth_label__LYNkJ","input":"Auth_input__RSz8N"};